import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modalContent: {
    backgroundColor: "#1B1D28",
    borderRadius: "20px",
    width: "600px",
    maxWidth: "95vw",
    padding: "24px",
    outline: "none",
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  title: {
    fontSize: "24px !important",
    fontWeight: "500 !important",
    color: theme.palette.text.primary,
  },
  subtitle: {
    fontSize: "12px !important",
    marginBottom: "16px !important",
  },
  label: {
    fontSize: "14px !important",
    color: theme.palette.text.tertiary,
    marginBottom: "8px !important",
  },
  searchField: {
    backgroundColor: "#252A38",
    borderRadius: "10px",
    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
    "& .MuiInputBase-input": {
      color: "#F9F9F9",
      padding: "10px",
      "&::placeholder": {
        color: "#7A7F90",
        opacity: 1,
      },
    },
  },
  resultsPopover: {
    marginTop: "8px !important",
    backgroundColor: "#252A38",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,.08)",
    boxShadow: "0px 19px 45px 0px #0000001F",
    overflow: "hidden",
  },
  resultsList: {
    maxHeight: "240px",
    overflowY: "auto",
    backgroundColor: "#252A38",
  },
  resultItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    padding: "12px 16px",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#34394A",
    },
  },
  resultItemSelected: {
    backgroundColor: "rgba(108, 101, 217, 0.15)",
  },
  pageName: {
    fontSize: "15px !important",
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  creatorSection: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
  },
  creatorLabel: {
    fontSize: "12px !important",
    color: theme.palette.text.tertiary,
    whiteSpace: "nowrap",
  },
  creatorPill: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "4px 10px 4px 4px",
    borderRadius: "50px",
    border: "1px solid #606479",
  },
  creatorName: {
    fontSize: "12px !important",
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
  },
  divider: {
    borderColor: "rgba(255,255,255,.06)",
  },
}));

export default useStyles;
